module.exports = __webpack_public_path__ + "img/orderSuggestion.8a482de4.png";